exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../colours.icss"), undefined);

// module
exports.push([module.id, ".AddButton__button___2bb6L {\n\ttext-transform: none!important;\n\tdisplay: flex;\n\talign-items: center;\n\tpadding-right: 1.25rem!important;\n}\n\n.AddButton__icon___3hAXy {\n\tmargin-left: 0.3rem;\n\tdisplay: flex;\n}\n\n.AddButton__content___1L9D- {\n\tdisplay: flex;\n\tcolor: " + require("-!../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../colours.icss").locals["secondaryColour"] + ";\n}\n", ""]);

// exports
exports.locals = {
	"secondaryColour": "" + require("-!../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../colours.icss").locals["secondaryColour"] + "",
	"button": "AddButton__button___2bb6L",
	"icon": "AddButton__icon___3hAXy",
	"content": "AddButton__content___1L9D-"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/AddButton.icss
// module id = 1319
// module chunks = 0